import PropTypes from 'prop-types';
import React from 'react';
import './SummaryNumber.css';
import {parseDocument} from 'utilities/DOM';

const NO_SUMMARY_NUMBER = 'No Summary Number';

const SummaryNumber = ({
  number,
  label = '',
  size = SummaryNumber.SIZES.MEDIUM,
}) => {
  if (label === NO_SUMMARY_NUMBER) return null;
  const doc = parseDocument(label);
  const escapedLabel = doc && doc.body ? doc.body.textContent : '';

  return (
    <div className="SummaryNumber">
      <div className={`SummaryNumber__Number SummaryNumber__Number--${size}`}>
        {number}
      </div>
      <div className="SummaryNumber__Label">{escapedLabel}</div>
    </div>
  );
};

SummaryNumber.SIZES = {
  MICRO: 'micro',
  MEDIUM: 'medium',
};

SummaryNumber.propTypes = {
  number: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.oneOf(Object.values(SummaryNumber.SIZES)),
};

export default SummaryNumber;
